module.exports = __webpack_public_path__ + "img/part_6_1.d2ea48b1.webp";